<template>
  <div class="maintenance_record" ref="myElementRef">
    <div ref="searchBox">
      <hc-search :data="searchData" @serch="getSearch" />
    </div>
    <div class="table_box">
      <hc-table :loading="state.loading"
        :tableData="state.tableData"
        :column="state.tableHeader"
        :offsetHeight="state.offsetHeight"
        :maxPage="maxPage"
        @pageChange="pageChange"
        @limitChange="limitChange"
      />
    </div>
  </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, toRaw } from "vue";
import { duplicateMonthListApi } from "@/api/maintenance/maintenance.js";
import { listToMap } from "@/utils/utils";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyMaintenanceDuplicateLabels } from "@/utils/maintenanceListI18n.js";
import { ElMessage } from "element-plus";

const currentMonth = () => {
  const now = new Date();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  return `${now.getFullYear()}-${m}`;
};

const myElementRef = ref();
const searchBox = ref();

let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);

const searchData = reactive([
  {
    label: "月份",
    type: "month",
    value: currentMonth(),
    defaultValue: currentMonth(),
    field: "month",
  },
]);

const state = reactive({
	loading: false,
  column: [
    { prop: "device_list_id", show: false, label: "设备ID" },
    { show: true, type: "index", label: "序号", width: 80 },
    { prop: "code", show: true, label: "机号", width: 140 },
    { prop: "title", show: true, label: "设备名称", width: 180 },
    { prop: "user_count", show: true, label: "重复机手数", width: 120 },
    { prop: "machinist_names", show: true, label: "重复机手" },
    { prop: "first_checkin_time", show: true, label: "首次选重时间", width: 180 },
    { prop: "last_checkin_time", show: true, label: "最近选重时间", width: 180 },
  ],
  offsetHeight: 0,
  tableHeader: [],
  tableData: [],
});

const applyLabels = () => {
  applyMaintenanceDuplicateLabels({ searchData, columns: state.column });
  tableHeaderFn();
};
const { t } = usePageI18n(applyLabels);

const offHeighths = () => {
  if (myElementRef.value) {
    state.offsetHeight =
      myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
  }
};

const pageChange = (currentPage) => {
  page.value = currentPage;
  getSearch(searchData);
};

const limitChange = (currentLimit) => {
  limit.value = currentLimit;
  page.value = 1;
  getSearch(searchData);
};

const getSearch = (params = []) => {
  const form = listToMap(toRaw(params), { value: "value", key: "field" });
  const requestParams = {
    page: page.value,
    limit: limit.value,
    month: form.month || "",
  };
  state.loading = true;
  duplicateMonthListApi(JSON.stringify(requestParams))
    .then((res) => {
      if (res?.code !== 200) {
        maxPage.value = 0;
        state.tableData = [];
        ElMessage.warning(res?.msg || t("maintenanceDuplicate.loadFailed"));
        return;
      }
      maxPage.value = res?.maxPage ?? 0;
      state.tableData = res?.data ?? [];
    })
    .catch(() => {
      maxPage.value = 0;
      state.tableData = [];
      ElMessage.error(t("maintenanceDuplicate.loadFailed"));
    })
    .finally(() => {
      state.loading = false;
    });
};

const tableHeaderFn = () => {
  state.tableHeader = state.column.filter((v) => {
    if (v.show) return v.show == true;
    v.show = false;
  });
};

onMounted(() => {
  nextTick(() => offHeighths());
  window.onresize = () => nextTick(() => offHeighths());
  applyLabels();
  getSearch(searchData);
});

onUnmounted(() => {
  window.onresize = null;
});
</script>

<style lang="less" scoped>
.maintenance_record {
  overflow: auto;
  background-color: #fff;
  border-radius: 6px;
  padding: 10px;
  margin-right: 10px;
  width: 100%;
  height: 100%;
}

.table_box {
  width: 100%;
}
</style>
